/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'CATEDRAL DE VALÈNCIA',
        preferVisitRead: 'Prefiero leer',
        preferVisitListten: 'Prefiero escuchar',
        downloadAudio: '(Downloading)',
        download:'Descarregant',
        errorDownload: 'Error en la descàrrega.',
        cancelDownload: 'Has cancel.lat la descàrrega.',
        initDownload: 'Si us plau, espereu mentre es descarreguen els àudios',
        endDownload: 'Àudios descarregats. Gaudiu de la visita!',
        retry: 'Reintentar',
        noConnection: 'No tens conexió a internet',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Benvinguda',
                author: 'Per favor, use auriculars',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Capella de Sant Sebastià',
                author: 'Peu de la nau',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Capella de Sant Pere Apòstol',
                author: 'Nau lateral dreta',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Capella de St. Francesc de Borja',
                author: 'Nau lateral dreta',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Finestra esbiaixada',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Altar Major',
                author: 'Capella Major',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Àngels músics',
                author: 'Capella Major',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Cimbori',
                author: 'Creuer',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Porta de l\'Almoina',
                author: 'Braç dret del creuer',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Girola + Òrgan',
                author: 'Girola',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'La Resurrecció',
                author: 'Capelles de la girola',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Crist de la Bona Mort',
                author: 'Capelles de la girola',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Verge de la Cadira + St. Jaume',
                author: 'Capelles de la girola',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'St. Dionís i Sta. Margarida',
                author: 'Capelles de la girola',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Porta dels Apòstols',
                author: 'Braç esquerre del creuer',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Continuació de la visita',
                author: 'Nau lateral esquerra',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Custòdia',
                author: 'Museu: Planta Baixa',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Mal lladre + Adoració',
                author: 'Museu: Planta Baixa',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Maquetes',
                author: 'Museu: Segona planta',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apòstols ',
                author: 'Museu: Segona planta',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Dubte de St. Tomàs + Dormició',
                author: 'Museu: Segona planta',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Relicari',
                author: 'Museu: Segona planta',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Improperis',
                author: 'Museu: Segona planta',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Passadís + Art barroc',
                author: 'Museu: Segona planta',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Excavació arqueològica',
                author: 'Museu: Soterrani',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Llibres de cor + Santa Cena',
                author: 'Museu: Planta Baixa',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'El Sant Calze',
                author: 'Capella del Sant Calze',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Capella del Sant Calze',
                author: 'Capella del Sant Calze',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'El Micalet ',
                author: 'Peu de la nau',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Crèdits',
                isCredits:true,
                author: '',
                description: 'Trama Media per a la Catedral de València.<br><br>© Catedral de València.<br><br>Tots els drets reservats.<br><br>',
                audio: '',
                idCreditImage: 30,
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/valenciano.js